(function () {
  var allowedProductHandles = ['color-by-number-book'];
  var match = window.location.pathname.match(/^\/products\/([^/?#]+)/);
  var currentProductHandle = match && match[1];
  var currentScript = document.currentScript;
  var currentProductId = currentScript && currentScript.dataset ? currentScript.dataset.productId : null;

  if (allowedProductHandles.indexOf(currentProductHandle) === -1) return;
  if (window.__ptbMetaAddToCartFallbackInstalled) return;
  window.__ptbMetaAddToCartFallbackInstalled = true;

  var state = {
    lastAddToCartAt: 0,
    lastFallbackKey: '',
    lastFallbackAt: 0,
    fbqWrapped: false,
    fetchWrapped: false
  };

  function now() {
    return Date.now();
  }

  function rememberAddToCart() {
    state.lastAddToCartAt = now();
  }

  function isAddToCartFbqCall(args) {
    return (
      (args[0] === 'track' && args[1] === 'AddToCart') ||
      (args[0] === 'trackSingle' && args[2] === 'AddToCart') ||
      (args[0] === 'trackShopify' && args[2] === 'AddToCart')
    );
  }

  function copyFbqProperties(from, to) {
    for (var key in from) {
      try {
        to[key] = from[key];
      } catch (error) {
        // Some fbq properties can be read-only in certain browsers.
      }
    }
  }

  function wrapFbq() {
    if (typeof window.fbq !== 'function' || window.fbq.__ptbAddToCartWrapped) return;

    var originalFbq = window.fbq;
    var wrappedFbq = function () {
      if (isAddToCartFbqCall(arguments)) {
        rememberAddToCart();
      }

      return originalFbq.apply(this, arguments);
    };

    copyFbqProperties(originalFbq, wrappedFbq);
    wrappedFbq.__ptbAddToCartWrapped = true;
    wrappedFbq.__ptbOriginalFbq = originalFbq;
    window.fbq = wrappedFbq;
    state.fbqWrapped = true;
  }

  function hasRecentAddToCart() {
    return state.lastAddToCartAt && now() - state.lastAddToCartAt < 1000;
  }

  function payloadKey(payload) {
    return [payload.content_ids.join(','), payload.value, payload.currency].join('|');
  }

  function hasRecentFallback(payload) {
    return state.lastFallbackKey === payloadKey(payload) && now() - state.lastFallbackAt < 3000;
  }

  function rememberFallback(payload) {
    state.lastFallbackKey = payloadKey(payload);
    state.lastFallbackAt = now();
  }

  function isCartAddRequest(input) {
    var requestUrl;

    if (typeof input === 'string') {
      requestUrl = input;
    } else if (input && typeof input.url === 'string') {
      requestUrl = input.url;
    } else if (input instanceof URL) {
      requestUrl = input.href;
    }

    if (!requestUrl) return false;

    try {
      return new URL(requestUrl, window.location.origin).pathname.replace(/\/+$/, '').endsWith('/cart/add.js');
    } catch (error) {
      return false;
    }
  }

  function asArray(value) {
    return Array.isArray(value) ? value : [value];
  }

  function moneyValue(value) {
    if (value == null || value === '') return 0;

    if (typeof value === 'string') {
      var parsed = parseFloat(value.replace(/[^0-9.-]/g, ''));
      return isNaN(parsed) ? 0 : parsed;
    }

    return Number(value) / 100;
  }

  function lineValue(item) {
    var quantity = Number(item.quantity) || 1;

    if (item.final_line_price != null) return moneyValue(item.final_line_price);
    if (item.line_price != null) return moneyValue(item.line_price);
    if (item.final_price != null) return moneyValue(item.final_price) * quantity;
    if (item.price != null) return moneyValue(item.price) * quantity;

    return 0;
  }

  function getProductId(item) {
    return item.product_id || (item.product && item.product.id) || item.id;
  }

  function buildPixelPayload(cartAddResponse) {
    var items = cartAddResponse && cartAddResponse.items ? cartAddResponse.items : cartAddResponse;
    var contentIds = [];
    var value = 0;
    var lineItems = asArray(items || []);
    var matchingItems = currentProductId
      ? lineItems.filter(function (item) {
          return item && String(getProductId(item)) === String(currentProductId);
        })
      : [];

    if (matchingItems.length) {
      lineItems = matchingItems;
    }

    lineItems.forEach(function (item) {
      if (!item || typeof item !== 'object') return;

      var productId = getProductId(item);
      if (productId) contentIds.push(String(productId));

      value += lineValue(item);
    });

    if (!contentIds.length) return null;

    return {
      content_ids: contentIds,
      content_type: 'product',
      value: Math.round(value * 100) / 100,
      currency: 'USD'
    };
  }

  function fireFallbackAddToCart(payload, attempt, cartAddStartedAt) {
    window.setTimeout(function () {
      wrapFbq();

      if (typeof window.fbq !== 'function') {
        if (attempt < 8) fireFallbackAddToCart(payload, attempt + 1, cartAddStartedAt);
        return;
      }

      if (hasRecentAddToCart()) return;
      if (hasRecentFallback(payload)) return;

      rememberFallback(payload);
      window.fbq('track', 'AddToCart', payload);
    }, attempt === 0 ? 5000 : 250);
  }

  function handleCartAddResponse(response, cartAddStartedAt) {
    response
      .clone()
      .json()
      .then(function (cartAddResponse) {
        var payload = buildPixelPayload(cartAddResponse);
        if (payload) fireFallbackAddToCart(payload, 0, cartAddStartedAt);
      })
      .catch(function () {});
  }

  wrapFbq();

  var fbqWrapAttempts = 0;
  var fbqWrapTimer = window.setInterval(function () {
    wrapFbq();
    fbqWrapAttempts += 1;

    if (fbqWrapAttempts >= 40) {
      window.clearInterval(fbqWrapTimer);
    }
  }, 250);

  function wrapFetch() {
    if (typeof window.fetch !== 'function' || window.fetch.__ptbMetaAddToCartWrapped) return;

    var originalFetch = window.fetch;
    var wrappedFetch = function () {
      var isCartAdd = isCartAddRequest(arguments[0]);
      var cartAddStartedAt = isCartAdd ? now() : 0;

      return originalFetch.apply(this, arguments).then(function (response) {
        if (isCartAdd && response && response.ok) {
          handleCartAddResponse(response, cartAddStartedAt);
        }

        return response;
      });
    };

    wrappedFetch.__ptbMetaAddToCartWrapped = true;
    window.fetch = wrappedFetch;
    state.fetchWrapped = true;
  }

  wrapFetch();

  var fetchWrapAttempts = 0;
  var fetchWrapTimer = window.setInterval(function () {
    wrapFetch();
    fetchWrapAttempts += 1;

    if (fetchWrapAttempts >= 40) {
      window.clearInterval(fetchWrapTimer);
    }
  }, 250);
})();
